import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
} from 'mdb-react-ui-kit';
import { useState } from 'react';


export default function CreateClubPopUp(props){
    const [newClubName, setNewClubName] = useState('');
    const [newClubGenre, setNewClubGenre] = useState('');

    async function handleCreateClub(evt){
        // Send data upwards to create a club
        console.log("vi kör handlecreateclub", newClubName, newClubGenre)
        await props.onCreateClub(newClubName, newClubGenre);
        if(props.clubsReady && (!props.error)){
            props.setShow(false);
            console.log("closing ")
            console.log(props.error)
        }
        
    }

    return <div className="mdb-scope">
        <MDBModal open={props.show} setOpen={props.setShow} tabIndex="-1">
        <MDBModalDialog centered={true} size="md"> 
            <MDBModalContent className="p-4 rounded-lg shadow-lg">
                <MDBModalHeader>
                    <MDBModalTitle className="font-semibold text-xl">Create New Book Club</MDBModalTitle>
                </MDBModalHeader>

                
                <MDBModalBody className="space-y-4 mt-4">
                    <div >
                        <label className="block mb-1 text-blue-900">Club Name</label>
                          <input
                                type="text"
                                value={newClubName}
                                onChange={(evt) => setNewClubName(evt.target.value)}
                                className="w-full px-4 py-2 border border-blue-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter club name"
                            />
                    </div>
                    <div>
                        <label className="block mb-1 text-blue-900">Genre</label>
                        <select
                            value={newClubGenre}
                            onChange={(evt) => setNewClubGenre(evt.target.value)}
                            className="w-full px-4 py-2 border border-blue-200 !rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 !cursor-pointer"
                        >
                            <option value="" className="text-gray-400">Select Genre</option>
                            <option value="Fiction">Fiction</option>
                            <option value="Fantasy">Fantasy</option>
                            <option value="Science Fiction">Science Fiction</option>
                            <option value="Horror">Horror</option>
                            <option value="Mystery">Mystery/Thriller</option>
                            <option value="Romance">Romance</option>
                            <option value="Literary fiction">Literary Fiction</option>
                            <option value="Non-fiction">Non-fiction</option>
                        </select>
                    </div>
                    {props.error && (
                        <div className="text-red-600 text-center mt-2">
                        Something went wrong. Please try again.
                        </div>
                    )}

                </MDBModalBody>

                <MDBModalFooter className="flex gap-2 justify-end mt-6">
                        <button
                            onClick={() => props.setShow(false)}
                            className="px-4 py-2 border border-blue-200 text-blue-700 !rounded-lg hover:bg-blue-50 transition-colors"
                        >
                        Cancel
                        </button>
                        <button
                            onClick={handleCreateClub}
                            disabled={!newClubName.trim() || !newClubGenre.trim()}
                            className={`px-6 py-2 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all
                                ${(!newClubName.trim() || !newClubGenre.trim()) ? "opacity-50 cursor-not-allowed" : ""}
                            `}
                        >
                        Create Club
                        </button>
                </MDBModalFooter>
            </MDBModalContent>
        </MDBModalDialog>
    </MDBModal>

</div>
}